import React, { Fragment, useEffect, useRef } from 'react'
import { Callback } from 'Src/types/utilTypes'
import { RequestParams } from 'Models'
import {
	Heading,
	HeadingType,
	Indent,
	LoaderSberComponent,
	GridBaseItem,
	GridGetItemsProps,
	RenderGridRowProps,
	GridUpBtn,
	GridInfinityScroll,
	GridRowColumnULStyled,
	GridRowWrapperStyled,
	TextType,
	Text,
} from 'LibNeo'
import { GridBackgroundBlockStyled, GridLoadingBlockStyled, GridWrapperStyled } from './styled'

interface ComponentProps<Item> {
	getItems: Callback<GridGetItemsProps>
	requestParams?: RequestParams
	data: Item[]
	className?: string
	renderGridRow: Callback<RenderGridRowProps>
	renderGridHeader: Callback
	total: number
	loading?: boolean
}
export const GridContainer = <Item extends GridBaseItem = GridBaseItem>({
	getItems,
	requestParams,
	data,
	className,
	renderGridRow,
	renderGridHeader,
	total,
	loading,
}: ComponentProps<Item>) => {
	const scrollElement = useRef<HTMLDivElement>()
	const prevDataLength = useRef<number | null>(null)

	useEffect(() => {
		if (prevDataLength.current > data.length) {
			prevDataLength.current = null
		}
	}, [data.length])

	const getData = () => {
		if (data.length >= total || loading || (!total && prevDataLength.current === data.length))
			return

		prevDataLength.current = data.length
		getItems({
			params: new RequestParams(
				requestParams.page + 1,
				requestParams.per_page,
				requestParams.query,
				requestParams
			),
			clear: false,
		})
	}

	const baseGrid = () => {
		if (!data.length && !loading)
			return (
				<GridBackgroundBlockStyled>
					<Indent bottom={12}>
						<Heading type={HeadingType.h4}>Нет данных</Heading>
					</Indent>
					<Text type={TextType.CAPTION} colorIndex={8}>
						Мы ничего не нашли по вашему запросу
					</Text>
				</GridBackgroundBlockStyled>
			)

		return (
			<>
				{renderGridHeader()}

				<GridInfinityScroll getData={getData} ref={scrollElement}>
					{data.length
						? data.map((item: Item) => <Fragment key={item.id}>{renderGridRow({ item })}</Fragment>)
						: null}

					{loading && (
						<GridRowWrapperStyled>
							<GridRowColumnULStyled>
								<GridLoadingBlockStyled fullScreen={!data.length}>
									<LoaderSberComponent size={32} />
								</GridLoadingBlockStyled>
							</GridRowColumnULStyled>
						</GridRowWrapperStyled>
					)}
				</GridInfinityScroll>
			</>
		)
	}

	return (
		<GridWrapperStyled className={className}>
			{baseGrid()}

			{scrollElement.current && (
				<GridUpBtn show={requestParams?.page > 1} element={scrollElement.current} />
			)}
		</GridWrapperStyled>
	)
}
